export default {
	paypalAuthorize: 'paypalAuthorize',
	twitchBits: 'twitchBits',
	coupon: 'coupon',
	brandProduct: 'brandProduct',
}
